export default __webpack_public_path__ + "static/media/budland.96a6f940.md";